//CONTROLAR LA DATA QUE SE ALMACENA POR CADA MENSAJE ENVIADO POR UN USUARIO
import * as firebase from 'firebase';

import Util from '../utils.js';

const database = firebase.firestore();

    //retorn todos las sesiones que han interactuado con Pablo  
    function getUsuarios(){
        let query = database.collection("sessions");

        const sesiones = [];

        return query.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                // console.log(doc.id, " => ", doc.data());
                sesiones.push(doc.id);
            });
            
            return Promise.resolve({
                sesiones
            });
        });
    }

    async function getHistoriales(){

        let {sesiones} = await getUsuarios();
        // console.log(sesiones);
        const body = new Map();
        let contador = 0;
        for (const iterator in sesiones) {
            console.log(sesiones[iterator])
            contador++;
            // let query = database.collection("sessions/"+ sesiones[iterator] +"/history");

            // query.get().then((querySnapshot) => {
            //     querySnapshot.forEach((doc) => {
            //         // console.log(doc.id, " => ", doc.data());
            //             body.set(sesiones[iterator], doc.data())
            //     });
            // });
            
        }

        console.log('contador :', contador);

        // return body;
    }


export default {
    getUsuarios,
    getHistoriales
}